"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OriflameLogo = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _useIsMarketCN = require("../../hooks/useIsMarketCN");
var _useTranslations = require("../../hooks/useTranslations");
var _components = require("./components");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const OriflameLogo = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const isMarketCN = (0, _useIsMarketCN.useIsMarketCN)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_constants.ORIFLAME_LOGO_ROOT),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledLink, {
      href: "/",
      "aria-label": translations.oriflameSweden,
      children: isMarketCN ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.ChineseLogo, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.CommonLogo, {})
    })
  });
};
exports.OriflameLogo = OriflameLogo;
